import React from "react";
import {
  Box,
  FormControlLabel,
  Radio,
  RadioGroup,
  Typography,
} from "@mui/material";

const FormRadioGroup = ({
  label,
  required,
  value,
  onChange,
  options,
  error,
}) => {
  return (
    <Box>
      <Typography
        sx={{
          fontSize: 12.5,
          fontWeight: 650,
          color: "#3A4441",
          mb: 0.75,
        }}
      >
        {label}
        {required && (
          <Box component="span" sx={{ color: "#B3261E" }}>
            {" "}
            *
          </Box>
        )}
      </Typography>

      <RadioGroup
        row
        value={value || ""}
        onChange={(e) => onChange(e.target.value)}
      >
        {options.map((option) => (
          <FormControlLabel
            key={option}
            value={option}
            control={
              <Radio
                size="small"
                sx={{
                  color: "#E6ECEA",
                  "&.Mui-checked": { color: "#0E7A6E" },
                }}
              />
            }
            label={option}
          />
        ))}
      </RadioGroup>

      {error && (
        <Typography sx={{ fontSize: 11.5, color: "#B3261E", mt: 0.25 }}>
          {error}
        </Typography>
      )}
    </Box>
  );
};

export default FormRadioGroup;
